export enum HobbyCategory {
  Sport = "Sport",
  Music = "Music",
  Culture = "Culture",
  Technology = "Technology",
  Others = "Others",
}
